'use-client';
import React from 'react';
import classNames from 'clsx';
import type { VerticalLineProps } from '../VerticalLine';
import skinsStyle from './styles/VerticalLineSkin.scss';

const VerticalLineSkin: React.FC<VerticalLineProps> = ({
  id,
  className,
  onMouseEnter,
  onMouseLeave,
  isClassNameToRootEnabled,
}) => {
  const rootClassName = isClassNameToRootEnabled ? className : '';

  return (
    <div
      id={id}
      className={classNames(skinsStyle.root, rootClassName)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={skinsStyle.lineCnt}>
        <div className={skinsStyle.line} />
      </div>
      <div className={skinsStyle.topKnobCnt} />
      <div className={skinsStyle.middleKnobCnt} />
      <div className={skinsStyle.bottomKnobCnt} />
    </div>
  );
};

export default VerticalLineSkin;
